const cartRoute = [
  {
    path: '/cart',
    name: 'cart',
    component: () => import(/* webpackChunkName: "route-cart" */ '@/views/revision/cart'),
  },
];

export default cartRoute;
